import loadable from '@/utils/loadable';
import Loader from '../ui/loader';

export const NotFoundPage = loadable(() => import('@/pages/NotFoundPage'), {
  fallback: <Loader />,
});

export const Login = loadable(() => import('@/pages/auth/LoginPage'), {
  fallback: <Loader />,
});

export const DashboardPage = loadable(() => import('@/pages/dashboard/DashboardPage'), {
  fallback: <Loader />,
});
export const OnboardingPage = loadable(() => import('@/pages/onboarding/OnboardingPage'), {
  fallback: <Loader />,
});
export const AccountDetails = loadable(
  () => import('@/pages/Downline/AccountDetails/AccountDetails'),
  {
    fallback: <Loader />,
  }
);
export const AccountSummary = loadable(
  () => import('@/pages/Downline/AccountDetails/AccountSummary'),
  {
    fallback: <Loader />,
  }
);
export const TransactionHistory = loadable(
  () => import('@/pages/Downline/AccountDetails/TransactionHistory'),
  {
    fallback: <Loader />,
  }
);
export const UserAccountStatement = loadable(
  () => import('@/pages/Downline/AccountDetails/UserAccountStatement'),
  {
    fallback: <Loader />,
  }
);
export const SettlementReport = loadable(
  () => import('@/pages/Downline/AccountDetails/SettlementReport'),
  {
    fallback: <Loader />,
  }
);

export const UserBetHistory = loadable(
  () => import('@/pages/Downline/AccountDetails/UserBetHistory'),
  {
    fallback: <Loader />,
  }
);
export const UserBettingPL = loadable(
  () => import('@/pages/Downline/AccountDetails/UserBettingPL'),
  {
    fallback: <Loader />,
  }
);
export const MemberSportSettings = loadable(
  () => import('@/pages/Downline/AccountDetails/MemberSportSettings'),
  {
    fallback: <Loader />,
  }
);
export const MemberChipSummary = loadable(
  () => import('@/pages/Downline/AccountDetails/MemberChipSummary'),
  {
    fallback: <Loader />,
  }
);
export const MemberUserSettings = loadable(
  () => import('@/pages/Downline/AccountDetails/MemberUserSettings'),
  {
    fallback: <Loader />,
  }
);

export const CasinoPl = loadable(
  () => import('@/pages/Downline/AccountDetails/BettingPlDetails/CasinoPl'),
  {
    fallback: <Loader />,
  }
);
export const SportsPL = loadable(
  () => import('@/pages/Downline/AccountDetails/BettingPlDetails/SportsPL'),
  {
    fallback: <Loader />,
  }
);
export const SportsPLEvent = loadable(
  () => import('@/pages/Downline/AccountDetails/BettingPlDetails/SportsPLEvent'),
  {
    fallback: <Loader />,
  }
);
export const SportsPLMarketBets = loadable(
  () => import('@/pages/Downline/AccountDetails/BettingPlDetails/SportsPLMarketBets'),
  {
    fallback: <Loader />,
  }
);
export const SportsPLSummary = loadable(
  () => import('@/pages/Downline/AccountDetails/BettingPlDetails/SportsPLSummary'),
  {
    fallback: <Loader />,
  }
);
export const SportsSummaryReport = loadable(
  () => import('@/pages/Downline/AccountDetails/BettingPlDetails/SportsSummaryReport'),
  {
    fallback: <Loader />,
  }
);
export const UserSportsBets = loadable(
  () => import('@/pages/Downline/AccountDetails/BetHistoryDetails/UserSportsBets'),
  {
    fallback: <Loader />,
  }
);
export const UserCasinoBets = loadable(
  () => import('@/pages/Downline/AccountDetails/BetHistoryDetails/UserCasinoBets'),
  {
    fallback: <Loader />,
  }
);

export const AllDownlineListing = loadable(() => import('@/pages/Downline/AllDownlineListing'), {
  fallback: <Loader />,
});
export const ContentManagement = loadable(() => import('@/pages/ContentManagement/'), {
  fallback: <Loader />,
});
export const BannerManagement = loadable(
  () => import('@/pages/ContentManagement/BannerManagement'),
  {
    fallback: <Loader />,
  }
);
export const SupportContactManagement = loadable(
  () => import('@/pages/ContentManagement/SupportContactManagement'),
  {
    fallback: <Loader />,
  }
);
export const NotificationManagement = loadable(
  () => import('@/pages/ContentManagement/NotificationManagement'),
  {
    fallback: <Loader />,
  }
);
export const SubUsers = loadable(() => import('@/pages/Downline/SubUsers'), {
  fallback: <Loader />,
});
export const CasinoControl = loadable(() => import('@/pages/CasinoManagement/CasinoControl'), {
  fallback: <Loader />,
});
export const CategoryControl = loadable(() => import('@/pages/CasinoManagement/CategoryControl'), {
  fallback: <Loader />,
});
export const ProviderControl = loadable(() => import('@/pages/CasinoManagement/ProviderControl'), {
  fallback: <Loader />,
});
export const GameControl = loadable(() => import('@/pages/CasinoManagement/GameControl'), {
  fallback: <Loader />,
});
export const FilteredGames = loadable(() => import('@/pages/CasinoManagement/FilteredGames'), {
  fallback: <Loader />,
});

export const Setting = loadable(() => import('@/pages/settings/ChnagePassword'), {
  fallback: <Loader />,
});

// Affiliate Management
export const CasinoDetail = loadable(() => import('@/pages/Downline/AccountDetails/CasinoPanel'), {
  fallback: <Loader />,
});

// Event Management
export const EventManagement = loadable(() => import('@/pages/EventManagement/EventManagement'), {
  fallback: <Loader />,
});

export const EventFixtures = loadable(
  () => import('@/pages/EventManagement/EventFixtures/EventFixtures'),
  { fallback: <Loader /> }
);

export const BetSetting = loadable(() => import('@/pages/EventManagement/BetSetting'), {
  fallback: <Loader />,
});

// Common component
export const TransactionCode = loadable(() => import('@/components/common/TransactionCode'), {
  fallback: <Loader />,
});

// Reports
export const BetList = loadable(() => import('@/pages/Reports/BetList'), { fallback: <Loader /> });

export const PlDownline = loadable(() => import('@/pages/Reports/PlDownline'), {
  fallback: <Loader />,
});

export const PlByPlayer = loadable(() => import('@/pages/Reports/PlByPlayer'), {
  fallback: <Loader />,
});

export const PlByEvent = loadable(() => import('@/pages/Reports/PlByEvent'), {
  fallback: <Loader />,
});

export const CasinoBetList = loadable(() => import('@/pages/Reports/CasinoBetList'), {
  fallback: <Loader />,
});

export const CasinoPlByPlayer = loadable(() => import('@/pages/Reports/CasinoPlbyPlayers'), {
  fallback: <Loader />,
});

export const CasinoPlByDownline = loadable(() => import('@/pages/Reports/CasinoPlByDownline'), {
  fallback: <Loader />,
});
export const InactiveMemerList = loadable(() => import('@/pages/Reports/InactiveMemeber'), {
  fallback: <Loader />,
});

export const BussinessReports = loadable(
  () => import('@/pages/Reports/BusinessReport/BussinessReports'),
  {
    fallback: <Loader />,
  }
);

export const RoleWiseAccountStatement = loadable(() => import('@/pages/RoleWiseAccountStatement'), {
  fallback: <Loader />,
});

export const StatementBets = loadable(
  () => import('@/pages/RoleWiseAccountStatement/StatementBets'),
  {
    fallback: <Loader />,
  }
);

export const Settlement = loadable(() => import('@/pages/Settlement'), {
  fallback: <Loader />,
});

// report settlement & balance sheet
export const ChipSettlement = loadable(
  () => import('@/pages/Reports/SettlementSheet/ChipSettlement'),
  { fallback: <Loader /> }
);
export const BalanceSheet = loadable(() => import('@/pages/Reports/SettlementSheet/BalanceSheet'), {
  fallback: <Loader />,
});
export const SettlementHistory = loadable(
  () => import('@/pages/Reports/SettlementSheet/SettlementHistory'),
  { fallback: <Loader /> }
);

export const TopClients = loadable(() => import('@/pages/Reports/TopClients'), {
  fallback: <Loader />,
});

// add promotion
export const AddPromotion = loadable(() => import('@/pages/AddPromotion'), {
  fallback: <Loader />,
});

// add client
export const CreateClient = loadable(() => import('@/pages/CreateClient/CreateClient'), {
  fallback: <Loader />,
});

// Games Dashboard
export const GamesDashboard = loadable(() => import('@/pages/dashboard/GamesDashboard'), {
  fallback: <Loader />,
});

// Sport Analysis
export const SportAnalysis = loadable(() => import('@/pages/SportAnalysis/SportAnalysis'), {
  fallback: <Loader />,
});
export const SportAnalysisEventDetails = loadable(
  () => import('@/pages/SportAnalysis/EventDetails/EventDetails'),
  { fallback: <Loader /> }
);
export const SportAnalysisBetHistory = loadable(
  () => import('@/pages/SportAnalysis/BetHistory/BetHistory'),
  { fallback: <Loader /> }
);
export const MultiMarket = loadable(() => import('@/pages/MultiMarket/MultiMarket'), {
  fallback: <Loader />,
});
export const DwTransection = loadable(
  () => import('@/pages/Downline/AccountDetails/AccontSatatementTransection/DwTransection'),
  { fallback: <Loader /> }
);
// export const UserSportsBets = loadable(
//   () => import('@/pages/Downline/AccountDetails/BetHistoryDetails/UserSportsBets'),
//   { fallback: <Loader /> }
// );
